import axios from 'axios';
import axiosRetry from 'axios-retry';
import toastr from 'toastr';
import * as actions from './actionsTypes';
import messages from '../messages';
import errorManage from '../errorManage';
import ClassificationServices from './classification.services';

const client = axios.create({ baseURL: process.env.REACT_APP_URL });
axiosRetry(client, { retries: 5, retryDelay: axiosRetry.exponentialDelay });

export const getClassification = (params, iType) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_CLASSIFICATION,
      payload: true
    });
    // const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    // const resp = await client.get(iType === 1 ? '/api/app/Formal_Clasificacion/' : `/api/app/Funcional_Clasificacion/`, {
    //   headers: {
    //     'Content-Type': 'application/json',
    //     'Authorization': `Token ${token}`
    //   },
    //   params: data
    // });
    const resp = await ClassificationServices.getClassifications(params, iType);
    dispatch({
      type: actions.GET_CLASSIFICATION,
      payload: {
        classification: resp.data,
        classificationLength: resp.data.length
      }
    });
    dispatch({
      type: actions.CLASSIFICATION_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
        message = ex.response.data.mensaje;
      }else{
        errorManage(ex);
        message = messages.errorMessage;
      }
    }else{
      errorManage(ex);
      message = messages.errorMessage;
    }
    dispatch({
      type: actions.CLASSIFICATION_FAIL,
      payload: message,
    });
  }finally{
    dispatch({
      type: actions.LOADING_CLASSIFICATION,
      payload: false
    });
  }
}

export const saveClassification = (req, iType, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADER_CLASSIFICATION,
      payload: true
    });

    // const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    // const resp = await client.post(iType === 1 ? '/api/app/Formal_Clasificacion/' : `/api/app/Funcional_Clasificacion/`, data, {
    //   headers: {
    //     'Content-Type': 'application/json',
    //     'Authorization': `Token ${token}`
    //   }});
    const resp = await ClassificationServices.saveClassification(req, iType);
    const { classification, classificationLength } = getState().classification;
    const aClassification = [...classification, resp.data];
    dispatch({
      type: actions.GET_CLASSIFICATION,
      payload: {
        classification: aClassification,
        classificationLength: classificationLength + 1
      }
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    let message = null;
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
        message = ex.response.data.mensaje;
      }else{
        errorManage(ex);
        message = messages.errorMessage;
      }
    }else{
      errorManage(ex);
      message = messages.errorMessage;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  }finally{
    setShowModal(false)
    dispatch({
      type: actions.SAVE_LOADER_CLASSIFICATION,
      payload: false
    });
  }
}

export const editClassification = (req, id, index, iType, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_CLASSIFICATION,
      payload: true
    });

    // const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    // const resp = await client.put(iType === 1 ? `/api/app/Formal_Clasificacion/${id}/` : `/api/app/Funcional_Clasificacion/${id}/`, data, {
    // headers: {
    //   'Content-Type': 'application/json',
    //   'Authorization': `Token ${token}`
    // }});
    const resp = await ClassificationServices.editClassification(id, req, iType);
    const { classification, classificationLength } = getState().classification;
    classification[index] = resp.data;
    dispatch({
      type: actions.GET_CLASSIFICATION,
      payload: {
        classification: classification,
        classificationLength: classificationLength
      }
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    let message = null;
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
        message = ex.response.data.mensaje;
      }else{
        errorManage(ex);
        message = messages.errorMessage;
      }
    }else{
      errorManage(ex);
      message = messages.errorMessage;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  }finally{
    setShowModal(false)
    dispatch({
      type: actions.LOADING_CLASSIFICATION,
      payload: false
    });
  }
}

export const deleteClassification = (id, index, iType) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_CLASSIFICATION,
      payload: true
    });

    // const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    // const resp = await client.delete(iType === 1 ? `/api/app/Formal_Clasificacion/${id}/` : `/api/app/Funcional_Clasificacion/${id}/`, {
    // headers: {
    //   'Content-Type': 'application/json',
    //   'Authorization': `Token ${token}`
    // }});
    await ClassificationServices.deleteClassification(id, iType);
    const { classification, classificationLength } = getState().classification
    classification.splice(index, 1);
    dispatch({
      type: actions.GET_CLASSIFICATION,
      payload: {
        classification: classification,
        classificationLength: classificationLength-1
      }
    });
    dispatch({
      type: actions.CLASSIFICATION_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    let message = null;
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
        message = ex.response.data.mensaje;
      }else{
        errorManage(ex);
        message = messages.errorMessage;
      }
    }else{
      errorManage(ex);
      message = messages.errorMessage;
    }
    dispatch({
      type: actions.CLASSIFICATION_FAIL,
      payload: message,
    });
  }finally{
    dispatch({
      type: actions.LOADING_CLASSIFICATION,
      payload: false
    });
  }
}